import { createRouter, createWebHistory } from "vue-router";
import AIChat from "@/pages/AIChat.vue";
import DataUpdate from "@/pages/DataUpdate.vue";
const routes = [
	{ path: "/", name: "AIChat", component: AIChat, meta: { requiresAuth: true } },
	{ path: "/data-update", name: "DataUpdate", component: DataUpdate, meta: { requiresAuth: true } },
	{ path: "/:pathMatch(.*)*", redirect: "/" },
];
const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior() {
		return { left: 0, top: 0 };
	},
});
export default router;
